module.exports = __webpack_public_path__ + "img/commissionLeads.c57876fd.svg";